// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scroller[data-v-6656677e]{flex:1 0;overflow-y:auto}.scroller__loading[data-v-6656677e]{height:50px;display:flex;justify-content:center}\n", ""]);
// Exports
module.exports = exports;
